(function () {
    'use strict';

    angular
        .module('app')
        .factory('fileGuideService', fileGuideService);

    fileGuideService.$inject = [
        '$timeout',
        '$http',
        '$filter',
        '$q',
        'gridDataService',
        'searchService',
        '$state',
        'inboxService',
        '$localStorage',
        'libraryService',
        'storageService',
        'breadCrumbService',
        'loginService'
    ];

    function fileGuideService($timeout,
        $http,
        $filter,
        $q,
        gridDataService,
        searchService,
        $state,
        inboxService,
        $localStorage,
        libraryService,
        storageService,
        breadCrumbService, loginService) {
        var service = {
            tree: [],
            unselectNodes: unselectNodes,
            filterTree: filterTree,
            treeCache: [],
            currentQuery: "",
            title: "",
            uniqueId: 0,
            currentItem: {},
            getInboxTree: getInboxTree,
            libraryPicked: libraryPicked,
            inboxNodePicked: inboxNodePicked,
            fileGuideItemPicked: fileGuideItemPicked,
            getFileGuideList: getFileGuideList,
            getFileGuideTree: getFileGuideTree,
            getLibraryTree: getLibraryTree,
            clearSelectedNodes: clearSelectedNodes,
            currentAction: {},
            nodeClicked: nodeClicked,
            nodeExpanded: nodeExpanded,
            onFetchData: {},
            getData: getData,
            getCount: getCount,
            node: {},
            showFilter: true,
            processing: false,
            showFolder: false,
            mode: 1
        };

        service.showFolder = storageService.lbShowFolder ? storageService.lbShowFolder : false;
        //icon for the tree nodes
        var icon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABIElEQVQ4y6WTIU/DQBiGn7vUIJZmW5AEEuzI6ieYqcD1JxTHP0DwO9DrT6hCbGqCBNllGNySOZKGNDUkbD1Er0dPrLuFV12+3vf0zXffK5RStFUthjEQA7fYWgKJDPOkXRQNoFoMr4AUGNOtFRDJMN8YgG7OAB83FUAgw3wjdSE9oRl9NwUQ+/kgBmYAeD7i8qG+Uq5Rny/HQPeeHlg9kNEz4vzOfFVvUyjXXYBY7OcDBSD6E8T1o5P/6uPJgD1T7d1Af+IEEGcXKA2Qptpt1dZPYY4GoMp353719WoBlgDsCrfu7621nRL4W80W+eDfbadJs4kZMMbzEb3RcUDtdiXDPGheIQIydoWvHFzoVY7MEHUwAh0UHMIUWGH6T5x/AZhbbQlxY2seAAAAAElFTkSuQmCC";
        var expandedIcon = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAACXBIWXMAAAsSAAALEgHS3X78AAABR0lEQVQ4y62TMUvDUBSFv/vMoIiEtqBb6+YiNIPg0KFTFofiHxDqZH+J4K+wm2txbCkoKDh0SNFNhOLgIKYSSxGlyXNokiZg24Ce6eW+nHPfO+8e0VqTRNAp1IE6UCWNa6CpbLeZLEokEHQK20ALKLMYfeBQ2e4gFgjJDmCSDR5gKdsdqLDQisiSqyC5CqwVFwmYIQfx2/k6cA4gO6dI8WT6y+SD4K4Kn8+LhI7Fb+evIsPUfhfEmG37Y9CTtMnOEUy82Fgj5bY/JujV5raTzQOk1EA/nUWl6qydYYJhTu8/D6vFqTeGGZ8iFpBSAzZ2kb3L5W8wvEG/XACgksWs0KOHeK3CCUO/32ZjB18wuo9NVMBsNMePy7t7veRnM5pEByhjmMhWDVbWf2d/v6LfupGBfWW71v+MchgMKwwKGcJkpcL0lzj/AIiBfdrYw9a9AAAAAElFTkSuQmCC";

        //data request
        var dataRequest = {};
        //will keep a cache of custom view tree to prevent a server request
        var fileGuideTreeCache = {};

        return service;

        //unselects all the nodes recursively
        function unselectNodes(nodes) {
            if (!nodes) {
                nodes = service.tree;
            }
            angular.forEach(nodes, function (item, key) {
                if (typeof item === 'object') {
                    item.selected = false;
                    if (angular.isArray(item.children)) {
                        unselectNodes(item.children);
                    }
                }
            });
        }

        //filters the tree given a term
        function filterTree(query, prop) {
            service.currentQuery = query;
            if (service.treeCache.length == 0) {

            }
            if (!query) {
                query = '';
            }
            service.tree = $filter('cutTree')(service.treeCache, query, prop);

            angular.forEach(service.tree, function (item) {
                if (item.vaultType) {
                    item.expanded = true;
                }
            });

            return service.tree;
        }

        function getLibraryTree() {
            var deferred = $q.defer();
            service.processing = true;
            libraryService.getTree().then(function (data) {
                service.processing = false;
                service.data = data;
                selectCurrentNode();
                service.treeCache = angular.copy(data);
                deferred.resolve(service.data);
            });
            return deferred.promise;
        }

        function getInboxTree() {
            var deferred = $q.defer();
            service.processing = true;
            inboxService.getTree().then(function (data) {
                service.data = data;
                selectCurrentNode();
                service.processing = false;
                service.treeCache = angular.copy(data);
                service.tree = data;
                deferred.resolve(service.data);
            });

            return deferred.promise;
        }

        function getFileGuideList() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/fileguide/list').then(function (response) {
                deferred.resolve(response.data);
            });
            return deferred.promise;
        }

        function getFileGuideTree(item) {
            service.processing = true;
            service.uniqueId = 0;
            service.currentItem = item;
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/fileguide/TreeJIT/' + item.id).then(function (response) {
                var values = [];
                service.processing = false;
                var tree = buildTree(response.data.children, [], item.id, values);
                fileGuideTreeCache[item.id] = tree;
                service.treeCache = angular.copy(tree);
                deferred.resolve(tree);
                selectCurrentNode();
            });

            //if (fileGuideTreeCache[item.id]) {
            //    service.processing = false;
            //    service.treeCache = fileGuideTreeCache[item.id];               
            //    deferred.resolve(fileGuideTreeCache[item.id]);
            //    selectCurrentNode();
            //}
            //else {

            //}

            return deferred.promise;
        }

        //when a node is clicked, perform an action already specified when a menu item was picked.
        function nodeClicked(node) {
            
            //ignore inbox parents
            if (service.title.toLowerCase() == loginService.resourceStrings["INBOX"].toLowerCase()) {
                if (node.nodeType === 1 || node.nodeType === 5) {
                    return;
                }
            }
            $timeout(function () {
                clearSelectedNodes();
                //service.unselectNodes(service.tree);
                breadCrumbService.node = node;

                $timeout(function () {
                    node.selected = true;
                    gridDataService.processing = true;

                    if (service.currentAction(node)) {
                        $timeout(function () {
                            $state.go('layout.results.grid').then(function () {
                                gridDataService.reloadGrid();
                            });
                        });

                    };
                });
            });


        }

        function selectCurrentNode() {
            var node = null;
            if (service.data) {
                for (var i = 0; i < service.data.length; i++) {
                    node = breadCrumbService.node ? findNode(breadCrumbService.node, service.data[i].children) : null;
                    if (node) {
                        node.selected = true;
                        break;
                    }
                }
            }
            if (!node) {
                for (var i = 0; i < service.tree.length; i++) {
                    node = breadCrumbService.node ? findNode(breadCrumbService.node, service.tree[i].children) : null;
                    if (node) {
                        node.selected = true;
                        break;
                    }
                }

            }
        }

        function findNode(node, children) {
            var found = null;
            var idProp = "id";
            if (node.libId) {
                idProp = "libId";
            }

            if (children) {
                children.forEach(function (item) {
                    if (item[idProp] === node[idProp] && item.name === node.name) {
                        found = item;
                    }
                    else {
                        if (!found) {
                            found = findNode(node, item.children);
                        }
                    }
                });
            }
            return found;
        }

        function clearSelectedNodes() {
            service.unselectNodes(service.tree);
            service.unselectNodes(service.data);
            for (var p in fileGuideTreeCache) {
                service.unselectNodes(p);
            }
        }

        //when a library is picked
        function libraryPicked(item) {

            //ignore vaults
            if (item.vaultType) {
                return false;
            }
            var criteria = [{
                schemaID: 'SCHEMA_S_LIBID',
                valueStr: "=" + item.libId,
                startDate: "",
                endDate: "",
                searchOp: 0,
                name: item.name,
                bSystem: true // System searches are not saved as last search.
            }];

            searchService.searchCriteria = (criteria === undefined) ? vm.criteria : criteria;

            gridDataService.genericDataService = searchService;
            //must identify the service in order to inject the correct one.
            gridDataService.serviceIdentifier = "searchService";
            //reset, since it's a new search
            gridDataService.totalRecords = 0;
            return true;
        }

        //when a file guide node is picked, set the service name in the grid data service
        function fileGuideItemPicked(item) {


            service.node = item;
            gridDataService.serviceIdentifier = "fileGuideService";
            gridDataService.totalRecords = 0;
            return true;
        }

        //when an inbox node is picked.
        function inboxNodePicked(node) {
            //ignore top level
            if (node.nodeType == 1 || node.nodeType == 5) {
                return false;
            }
            inboxService.node = node;
            gridDataService.serviceIdentifier = "inboxService";
            gridDataService.totalRecords = 0;
            return true;
        }


        //this will get the data for the fileguide nodes
        function getData(skip, take, totalRecords, sort, sortOrder, countOperation, resultType, columns) {
            if (!service.node.id) {
                service.node = $localStorage.userSettings["node"];
            }
            else {
                $localStorage.userSettings["node"] = service.node;
            }

            dataRequest = $q.defer();
            var canceller = $q.defer();

            var cancel = function (reason) {
                canceller.resolve(reason);
            }
            var node = service.node;

            var requestData = JSON.stringify({
                FileGuideId: node.id,
                Values: node.values,
                Sort: { SortField: sort, SortOrder: sortOrder },
                Skip: skip,
                Take: take,
                ResultType: resultType,
                Columns: columns
            });

            breadCrumbService.category = loginService.resourceStrings["FILE_GUIDE"];
            breadCrumbService.details = service.currentItem.name + " / " + node.values.join(" / ");

            var responseType = resultType == 2 || resultType == 3 ? "arraybuffer" : "";
            var request = $http({
                url: '../Synergis.WebApi/api/FileGuide/data/',
                method: 'POST',
                data: requestData,
                responseType: responseType,
                timeout: canceller.promise,
                headers: {
                    "Content-Type": "application/json"
                }
            }).then(function (response) {
                dataRequest.resolve(response);
            }, function (response) {
                dataRequest.reject(response);
            });

            return {
                promise: dataRequest.promise,
                cancel: cancel
            }
        }

        function getCount() {
            var deferred = $q.defer();
            dataRequest.promise.then(function (response) {
                deferred.resolve(response.data.AdeptDataTable.RecordCount);
            });
            return deferred.promise;
        }

        function nodeExpanded(node) {
            var deferred = $q.defer();
            node.children = undefined;
            if (!node.children) {
                $http({
                    url: '../Synergis.WebApi/api/fileguide/children/' + node.id,
                    method: 'POST',
                    data: JSON.stringify(node),
                    headers: {
                        "Content-Type": "application/json"
                    }
                }).then(function (response) {
                    //add a unique id
                    var index = 0;
                    for (var i = 0; i < response.data.children.length; i++) {
                        response.data.children[i].uniqueId = index;
                        index++;
                        response.data.children[i].icon = icon;
                        response.data.children[i].expandedIcon = expandedIcon;

                        response.data.children[i].values = [];
                        for (var prop in response.data.children[i].map) {
                            response.data.children[i].values.push(response.data.children[i].map[prop]);
                        }
                    }

                    deferred.resolve(response.data);
                });
            }
            else {
                deferred.resolve();
            }

            return deferred.promise;
        }

        function buildTree(data, tree, id, values) {
            //recursively build the tree

            angular.forEach(data, function (item, key) {
                item.icon = icon;
                item.expandedIcon = expandedIcon;
                //set the item's id and values
                item.id = id;
                item.values = values.concat([item.name]);
                //build the item's children
                var children = buildTree(item.children, [], id, item.values);
                //set the children
                item.children = children.length > 0 ? children : null;
                //check for vault and expand
                if (item.vaultType) {
                    item.expanded = true;
                }
                //add single item
                service.uniqueId = service.uniqueId + 1;
                item.uniqueId = service.uniqueId;
                tree.push(item);

            })
            return tree;
        }


    }
})();